import { useMemo } from "react";
import { useTranslation } from "../../localization";
import getMediaFileMetadata from "../metadata/getMediaFileMetadata";
export default function useMediaFileMetadata(file) {
    const { t } = useTranslation();
    return useMemo(() => getMediaFileMetadata(file, t), [file, t]);
}
